import { useEffect } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
import '../../../hooks/index.js';
import { useMenuContext } from '../MenuContext.js';
import { useDidUpdate } from '../../../hooks/useDidUpdate/useDidUpdate.js';

const useMaskDimensions = (target, animatedLeft, paneDepth, children, isVirtualized, isVirtualizationReady) => {
  var _process$env;
  const {
    setMaskHeight,
    maskHeight,
    setMaskWidth,
    openPaneDepth,
    open
  } = useMenuContext();
  const auto = 'auto';
  const updateMaskDimensions = function () {
    let reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (target) {
      setMaskHeight(reset ? auto : target.clientHeight);
      setMaskWidth(reset ? auto : target.clientWidth);
    }
  };

  // resets dimensions on menu close so that the top-level pane reopens immediately, rather than animating
  useEffect(() => {
    updateMaskDimensions(!open);
  }, [open]);

  // handles async children adjustments by consumer
  useDidUpdate(() => {
    if (paneDepth === openPaneDepth) {
      updateMaskDimensions();
    }
  },
  // ignoring other dependencies because this should only run when the children change
  [children]);

  // handles returning to this pane by traversing backwards
  useDidUpdate(() => {
    if (!animatedLeft) {
      updateMaskDimensions();
    }
  }, [animatedLeft]);

  // handles dynamic resizing by both radix and virtuoso
  useResizeObserver(target, () => {
    if (openPaneDepth === paneDepth) {
      updateMaskDimensions();
    }
  });

  // determines if the mask is ready
  return (maskHeight !== auto || typeof process !== 'undefined' && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'test') && (isVirtualized ? isVirtualizationReady : true);
};

export { useMaskDimensions as default };
